<!-- Vertical Menu -->
@if (menuType === 'vertical-menu') {
  <xbaht-vertical-menu></xbaht-vertical-menu>
}
<!--/ Vertical Menu -->

<!-- Horizontal Menu -->
@if (menuType === 'horizontal-menu') {
  <xbaht-horizontal-menu></xbaht-horizontal-menu>
}
<!--/ Horizontal Menu -->